// extracted by mini-css-extract-plugin
export default {"modal":"pVPfZOGGXTzfctn75H8Y"};